import isNil from 'lodash/isNil'
import { Map } from 'immutable'

import 'store/types'
import './types'

export function selectCheckout (state) {
  const { checkout = Map() } = state
  return checkout
}

export function selectPaypalReady (state) {
  const checkout = selectCheckout(state)
  const paypalReady = checkout.get('paypalToken')
    && !checkout.get('brianTreeProcessing')
    && checkout.get('brianTreeReady')
  return paypalReady
}

export function selectCheckoutHasError (state) {
  const { checkout = Map(), payment = Map() } = state
  const checkoutOrderError = checkout.get('orderError')
  const paymentError = payment.getIn(['data', 'payments', 'success']) === false || payment.getIn(['data', 'payments', 'error']) === true
  const paymentValidationError = payment.get('error')
  const errorShouldRender = checkoutOrderError || (paymentError || paymentValidationError)
  return errorShouldRender
}

export function selectPaymentProcessing (state) {
  const { checkout = Map() } = state
  return checkout.get('processing')
}

/**
 * @param {ReduxState} state redux state
 * @returns {PaymentType}
 */
export function selectPaymentType (state) {
  const checkoutState = selectCheckout(state)
  return checkoutState.get('paymentType')
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean} paypal authorization success
 */
export function selectPaypalAuthorizationSuccess (state) {
  const checkoutState = selectCheckout(state)

  const paypalPaymentInfo = checkoutState.get('paypalPaymentInfo')
  const billingValid = checkoutState.get('billingValid')
  return billingValid && !isNil(paypalPaymentInfo)
}

/**
 * @param {ReduxState} state redux state
 * @returns {String}
 */
export function selectOrderError (state) {
  const checkoutState = selectCheckout(state)
  return checkoutState.get('orderError')
}
